import { useSelector } from 'react-redux'
import { RbacResourceAccess } from '../../types/access'
import { useHavePermissions } from '../useHavePermissions'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { useEffect, useState } from 'react'

export const useHasUserPermissions = (resourceAccess: RbacResourceAccess[]) => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)
  const [hasAccess, setHasAccess] = useState(false)
  const { checkPermissions } = useHavePermissions()

  useEffect(() => {
    setHasAccess(user?.id ? checkPermissions({ resourceAccess }) : false)
  }, [user?.id, resourceAccess, checkPermissions])

  return hasAccess
}
